<script setup lang="ts">
/** Internal: provides the region context to one NxWorkspace region's content. */
import { provide, toRef } from 'vue';
import { nxWorkspaceRegionKey, type NxWorkspaceRegionName } from './context';

const props = defineProps<{
  region: NxWorkspaceRegionName;
  narrow: boolean;
  sidebarVisible: boolean;
}>();

provide(nxWorkspaceRegionKey, {
  region: props.region,
  narrow: toRef(props, 'narrow'),
  sidebarVisible: toRef(props, 'sidebarVisible'),
});
</script>

<template>
  <slot />
</template>
